export default "__VITE_ASSET__8d912bd7__"